export const contactFields = [
  {
    key: "name",
    id: "433404238",
    required: true,
    maxLength: 120,
    autoComplete: "name",
  },
  { key: "profession", id: "574101254", maxLength: 120 },
  { key: "specialty", id: "1892811547", maxLength: 120 },
  {
    key: "company",
    id: "946708606",
    maxLength: 160,
    autoComplete: "organization",
  },
  {
    key: "phone",
    id: "1038190053",
    type: "tel",
    maxLength: 40,
    autoComplete: "tel",
  },
  {
    key: "email",
    id: "718423431",
    type: "email",
    required: true,
    maxLength: 254,
    autoComplete: "email",
  },
  { key: "message", id: "685377980", required: true, maxLength: 3000 },
];

// Conservative checks for obvious placeholders, not a claim of semantic or spam detection.
function isObviousJunk(value) {
  const compact = value
    .normalize("NFKC")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]/gu, "");
  const randomCase = (value.match(/[A-Za-z]{14,}/g) || []).some((token) => {
    const upper = (token.match(/[A-Z]/g) || []).length;
    const lower = token.length - upper;
    const switches = [...token]
      .slice(1)
      .filter(
        (letter, index) =>
          (letter === letter.toUpperCase()) !==
          (token[index] === token[index].toUpperCase()),
      ).length;
    // Avoid rejecting all-caps names, acronyms, or ordinary Mc/Mac-style names.
    return upper >= 4 && lower >= 4 && switches >= 8;
  });
  return (
    randomCase ||
    /^(.)\1{3,}$/u.test(compact) ||
    /^(?:(?:asdf|qwerty|qwertz|azerty|zxcv|qazwsx|abcde?f?|teste?|testing|loremipsum|foobar|undefined|null|xxx)+\d*)$/.test(
      compact,
    )
  );
}

export function validateContactField(field, rawValue) {
  const value = rawValue.trim();
  if (!value) return field.required ? "required" : null;
  if (value.length > field.maxLength) return "tooLong";

  if (field.key === "email") {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? null : "email";
  }
  if (field.key === "phone") {
    const main = value.replace(/\s*(?:ext\.?|x|ramal)\s*\d{1,6}$/i, "");
    const digits = main.replace(/\D/g, "");
    return /^\+?[\d\s().-]+$/.test(main) &&
      digits.length >= 7 &&
      digits.length <= 15 &&
      !/^(\d)\1+$/.test(digits)
      ? null
      : "phone";
  }

  if (isObviousJunk(value)) return "junk";
  const letters = value.match(/\p{L}/gu) || [];
  if (field.key === "name") {
    // Single names, accents, non-Latin scripts, apostrophes and hyphens are welcome.
    return letters.length >= 2 && !/[\d@/:]/u.test(value) ? null : "name";
  }
  if (field.key === "message") {
    const withoutLinks = value.replace(/(?:https?:\/\/|www\.)\S+/gi, "");
    const words = withoutLinks.match(/[\p{L}\p{M}]+/gu) || [];
    const cjk =
      withoutLinks.match(
        /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/gu,
      ) || [];
    return letters.length >= 6 && (words.length >= 2 || cjk.length >= 6)
      ? null
      : "message";
  }
  // Optional professional fields accept abbreviations, such as RN, MD and IT.
  return letters.length >= 1 ? null : "text";
}
